
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/shipping-and-delivery",
      function () {
        return require("private-next-pages/content/shipping-and-delivery.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/shipping-and-delivery"])
      });
    }
  